// Store photos are served resized (WebP at fixed widths) by the host. These helpers turn a store file URL into the
// matching resized URLs. Anything that is not a store photo (videos, bundled assets, outside links) returns null.
export const STORE_IMAGE_WIDTHS = [240, 480, 720, 1080, 1440, 1920, 2560];
const CONTENT_URL = /^(.*)\/api\/public\/store\/files\/(\d+)\/content(?:\?(.*))?$/;

function parts(url) {
  const match = CONTENT_URL.exec(String(url || '').trim());
  return match && !/(?:^|&)media=video(?:&|$)/.test(match[3] || '') ? { origin: match[1], id: match[2] } : null;
}
export function storeImageUrl(url, width) {
  const found = parts(url);
  return found ? `${found.origin}/api/public/store/files/${found.id}/image/${width}.webp` : null;
}
export function storeImageSrcset(url) {
  return parts(url) ? STORE_IMAGE_WIDTHS.map((width) => `${storeImageUrl(url, width)} ${width}w`).join(', ') : null;
}
// The store data the host put in the page, so the first screen does not wait for a request. Read once.
let boot;
export function storeBoot() {
  if (boot === undefined) {
    try { boot = JSON.parse(document.getElementById('store-boot')?.textContent || 'null'); } catch { boot = null; }
  }
  return boot;
}
